<template>
    <div>
        <h1 class="m-4">帳戶列表</h1>
        <!-- <h3 class="m-3">123</h3> -->
        <table class="table">
            <thead>
                <tr>
                    <th scope="col">#</th>
                    <th scope="col">塔位編號</th>
                    <th scope="col">姓名</th>
                    <th scope="col">帳號</th>
                    <th scope="col">Email</th>
                    <th scope="col">暱稱</th>
                    <th scope="col">身分證字號</th>
                    <th scope="col">性別</th>
                    <th scope="col">身份</th>
                    <th scope="col">狀態</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="user in userInfo" :key="user.id">
                    <th scope="row">{{ user.id }}</th>
                    <td>{{ user.niche_id }}</td>
                    <td>{{ user.name }}</td>
                    <td>{{ user.account }}</td>
                    <td>{{ user.email }}</td>
                    <td>{{ user.nickname }}</td>
                    <td>{{ user.identity_card_number }}</td>
                    <td>{{ user.gender ? "女" : "男" }}</td>
                    <td>{{ user.role }}</td>
                    <td>{{ user.status ? "已啟用" : "未啟用"  }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
export default {
    props: {
    },
    data() {
        return {
            base_url,
            userInfo: {}
        }
    },
    mounted() {
        console.log('Component mounted.')
    },
    methods: {
        getUserInfo: function () {
            axios
                .get(base_url + '/admin/api/users')
                .then((response) => {
                    console.log(response.data);
                    this.userInfo = response.data;
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
    },
    created() {
        this.getUserInfo();
    },
}
</script>
